import {
  ChangeDetectionStrategy,
  Component,
} from '@angular/core';

@Component({
  selector: 'rb-isabel-redirect',
  templateUrl: './isabel-redirect.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class IsabelRedirectComponent {
}
